document.addEventListener("DOMContentLoaded", function () {
  const faqWrapper = document.querySelector(".article-faqs .metafield-rich_text_field");
  if (!faqWrapper) return;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": []
  };

  const headings = faqWrapper.querySelectorAll("h3");

  headings.forEach((heading) => {
    const question = heading.textContent.trim();
    let answer = "";
    let el = heading.nextElementSibling;

    while (el && el.tagName !== "H3") {
      if (el.tagName === "P") {
        answer += el.textContent.trim() + " ";
      } else if (el.tagName === "UL" || el.tagName === "OL") {
        const items = Array.from(el.querySelectorAll("li")).map(li => li.textContent.trim());
        if (items.length > 0) {
          answer += items.map((item, index) =>
            el.tagName === "OL" ? `${index + 1}. ${item}` : `• ${item}`
          ).join(" ") + " ";
        }
      }
      el = el.nextElementSibling;
    }

    if (question && answer.trim()) {
      faqSchema.mainEntity.push({
        "@type": "Question",
        "name": question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer.trim()
        }
      });
    }
  });

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(faqSchema);
  document.head.appendChild(script);
});